module.exports = __webpack_public_path__ + "img/color-companion-1_en.e0b2a85.jpg";